// @ts-nocheck
// Greif UI Kit = line-check-small
import * as React from "react";

const CheckboxChecked: React.FC = () => {
    /* Store Custom Code - Start */
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M15.729 7.073c.256-.246.602-.39.969-.405.366-.015.725.102 1.002.326s.452.54.489.88c.036.341-.068.682-.293.953l-6.528 8a1.47 1.47 0 0 1-1.128.52l-.187-.01a1.45 1.45 0 0 1-.942-.496L5.64 12.693l-.102-.138a1.26 1.26 0 0 1-.17-.973c.078-.333.29-.625.59-.817.302-.192.671-.269 1.032-.215.36.053.685.234.907.504l2.329 2.813 5.4-6.666h-.014z"
                clipRule="evenodd"
            />
        </svg>
    );
    /* Store Custom Code - End */
};

export default React.memo(CheckboxChecked);
